import { render, staticRenderFns } from "./MagicLinkLogin.vue?vue&type=template&id=e5ad34d2&scoped=true&"
import script from "./MagicLinkLogin.vue?vue&type=script&lang=js&"
export * from "./MagicLinkLogin.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkLogin.vue?vue&type=style&index=0&id=e5ad34d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ad34d2",
  null
  
)

export default component.exports